import React, {Component} from 'react';



class SelectActividades extends Component {


    render(){
        const {actividad, maneja, listado, disabled} = this.props; 

        return (
            <span>
                <select className="mb-2 select-cuerpo" onChange={maneja} value={actividad} disabled={disabled!=='' && disabled!==null && disabled!==undefined?disabled:false}>
                    <option>Seleccione</option>
                    {
                        listado.map(a => {
                            return <option key={a.id} value={JSON.stringify({id:a.id, nombre:a.nombre})}>{a.nombre}</option>
                        })
                    }
                </select>
            </span>
        )
    }
};

export default SelectActividades;